import React, { useCallback } from 'react'
import InvoiceItemList from './InvoiceItemList'
import {  useDispatch, useSelector } from 'react-redux'
import { TranslateContext } from '../TranslateContext'
import { useForm } from '../../../hooks'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { createInvoice } from '../../actions/itemTabActions'
import { updateInvoiceHeaderFieldValue } from '../../actions/InvoiceActions'
import ItemHeader from './itemHeader'
import { NL_fieldPatterns } from '../../util/NL_fieldPatterns'
import { createInvoiceStructure } from '../../util/itemsTabValidation'
import validate from 'validate.js'
import * as ActionTypes from '../../actions/actionTypes'
import MassUpdate from './massUpdate'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'

const InvoiceForm = () => {
  const dispatch = useDispatch()
  const { isLoading, saveForm } = useForm("")
  const translate = React.useContext(TranslateContext).translate
  const procedureList = useSelector((state) => state.DropDownValues.addProcedure110)
  const selectedHeaderProcedure = useSelector((state) => state.Shipment?.exitInfo?.procedure)

  const { isDMS, isImportShipment, isDisabled } = useCurrentShipmentType()

  const InvoiceItems = useSelector((state) => state.InvoicesReducer.invoices)

  const fieldPattern = NL_fieldPatterns(isDMS, isImportShipment)
  
  const filteredProcedureList=React.useMemo(()=>{
    if(isDMS && isImportShipment) {
      const mapping={"H1":["40","42","61","63","01","07","43","44","45","46","48","68"],"H2":["71"],"H3":["53"],"H4":["51"],"H5":["40","42","61","63","95","96"],"H6":["01","07","40"],"I1":["40","42","61","63","01","07","43","44","45","46","48","68","51","53"]}
      if(!mapping[selectedHeaderProcedure] || !procedureList?.length)
            return []
      return procedureList.filter(c=>mapping[selectedHeaderProcedure].some(d=>c.value.startsWith(d)))
    } 
    return procedureList
},[procedureList,isDMS,isImportShipment,selectedHeaderProcedure])

  const getInvoiceId = useCallback(async (length) => {
    const response = await saveForm({ "invoices": [{ "invoiceId": "" }] })
    if (response){
      let invErr = validate({[`invoiceId`]: response.responseMessage}, fieldPattern()?.items?.invoice()) || {}
      invErr = createInvoiceStructure(invErr,length) 
      dispatch({
        type: ActionTypes.UPDATE_VALIDATION_ERRORS,
        tabName:'items',
        payload:invErr
      })
      dispatch(createInvoice(response.responseMessage))
    }        
  }, [dispatch, saveForm])

  return (
    <div className="formContentareaC88" style={{ height: 'calc(100vh - 329px)' }}>

      <ItemHeader
        translate={translate}
        updateItemHeaderData={updateInvoiceHeaderFieldValue}
      /> 

      {!isDisabled && <MassUpdate />}     

      <InvoiceItemList procedureList={filteredProcedureList} InvoiceItems={InvoiceItems} fieldPattern={fieldPattern}/>

      {isLoading && <CustomLoader />}

      <AddBtn
        id={`add-invoice`}
        style={{ marginTop: '10px'}}
        onClick={()=>getInvoiceId(InvoiceItems?.length)}
        text="Add Invoice"
        iconClass=''
      >
      </AddBtn>

    </div>
  )
}

export default React.memo(InvoiceForm)
